<app-header></app-header>
<div class="container-fluid">
  <h2>FAANG Summary</h2>
  <hr>

  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" style="margin-bottom: 20px;">
    <mat-tab-group #tabs (selectedTabChange)="tabClick($event)" style="margin-bottom: 20px;">
      <mat-tab label="Organisms"></mat-tab>
      <mat-tab label="Specimens"></mat-tab>
      <mat-tab label="Datasets"></mat-tab>
      <mat-tab label="Files"></mat-tab>
    </mat-tab-group>

    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="defaultCheck1" (click)="onCheckboxClick()" checked>
      <label class="form-check-label" for="defaultCheck1">
        Show only FAANG data (exclude legacy data)
      </label>
    </div>
  </div>

  @defer (when !error) {
    <div fxLayout="column" fxLayoutGap="4%">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="4%">
        <mat-card fxFlex="48" class="card" style="max-height: 600px; padding: 10px;">
          <h3>Standard</h3>
          <span class="subheader">Click on legend to exclude item</span>
          <hr>
          <div class="center">
            <canvas baseChart
                    [datasets]="standardChartData"
                    [labels]="standardChartLabels"
                    [options]="doughnutChartOptions"
                    [type]="'doughnut'"
                    [legend]="true">
            </canvas>
          </div>
        </mat-card>
        <mat-card fxFlex="48" class="card" style="max-height: 600px; padding: 10px;">
          <h3>Paper published</h3>
          <span class="subheader">Click on legend to exclude item</span>
          <hr>
          <div class="center">
            <canvas baseChart
                    [datasets]="paperChartData"
                    [labels]="paperChartLabels"
                    [type]="'pie'"
                    [options]="pieChartOptions"
                    [plugins]="pieChartPlugins"
                    [legend]="true">
            </canvas>
          </div>
        </mat-card>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="4%">
        <mat-card fxFlex="48" class="card" style="max-height: 600px; padding: 10px;">
          <h3>Species</h3>
          <span class="subheader">Hover over bar to see full name</span>
          <hr>
          <div class="centerBarChart">
            <canvas baseChart
                    [data]="speciesChartData"
                    [type]="'bar'"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="false">
            </canvas>
          </div>
        </mat-card>
        <mat-card fxFlex="48" class="card" style="max-height: 600px; padding: 10px;">
          <h3>Assay type</h3>
          <span class="subheader">Hover over bar to see full name</span>
          <hr>
          <div class="centerBarChart">
            <canvas baseChart
                    [data]="assayTypeChartData"
                    [type]="'bar'"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="false">
            </canvas>
          </div>
        </mat-card>
      </div>
    </div>
  }
  @loading {
    <div> Loading charts... </div>
  } @error {
    <div fxLayout="row">
      <div fxFlex="100" class="alert alert-danger"><p>{{ error }}</p></div>
    </div>
  }

</div>
